import React from 'react';
import { Cake as CakeIcon } from '@mui/icons-material';
// eslint-disable-next-line import/no-extraneous-dependencies
import { format } from 'date-fns';
import { StyledListItem, StyledListItemIcon, StyledListItemText } from '../styles';
var CustomerListItemDOB = function (_a) {
    var dateOfBirth = _a.dateOfBirth;
    return (React.createElement(StyledListItem, null,
        React.createElement(StyledListItemIcon, null,
            React.createElement(CakeIcon, null)),
        React.createElement(StyledListItemText, { primary: dateOfBirth ? format(dateOfBirth, 'MM/dd/yyyy') : '', secondary: !dateOfBirth ? 'Missing' : '' })));
};
export default CustomerListItemDOB;
//# sourceMappingURL=CustomerListItemDOB.js.map